/**
 * `.onglets` du kit : choisir une vue parmi quelques-unes. L'onglet actif se dit
 * `aria-selected`, jamais une classe.
 */
export function Tabs<T extends string>({
  tabs,
  value,
  onChange,
  label,
}: {
  tabs: ReadonlyArray<{ id: T; label: string }>;
  value: T;
  onChange: (id: T) => void;
  label: string;
}): React.ReactElement {
  return (
    <div className="onglets" role="tablist" aria-label={label}>
      {tabs.map((t) => (
        <button
          key={t.id}
          type="button"
          role="tab"
          aria-selected={value === t.id}
          onClick={() => onChange(t.id)}
          className="onglet"
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}
